import React from 'react';
import { translate } from '../../../Services/translation';
import Icon from '../../Icon';
import { useNavigate } from 'react-router-dom';
import { remove as removeUser } from '../../../Actions/Person.action';
import { useDispatch } from 'react-redux';

const UserListItemMobile = ({ person }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <li className="mb-4 rounded border border-solid border-gray-300 bg-white p-4">
      <p className="mb-3 text-lg font-bold capitalize">
        {person.firstName} {person.lastName}
      </p>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        <div className="flex flex-col">
          <p className="text-sm uppercase text-gray-600">
            {translate('mypage.person.email')}:
          </p>
          <p className="text-md">{person.email}</p>
        </div>
        <div className="flex flex-col">
          <p className="text-sm uppercase text-gray-600">
            {translate('mypage.person.phone')}:
          </p>
          <p className="text-md">{person.phone}</p>
        </div>
        <div className="flex flex-col">
          <p className="text-sm uppercase text-gray-600">
            {translate('mypage.person.role')}:
          </p>
          <p className="text-md">{person.role}</p>
        </div>
        {person.role !== 'Admin' && (
          <div className="col-span-2 flex items-center gap-3 md:col-span-1 md:justify-end">
            <button
              className="btn btn--clear btn--small flex h-8 w-8 items-center border border-solid border-primary-500 text-primary-500"
              id="edit"
              onClick={() => navigate(`edit/${person.systemId}`)}
            >
              <Icon
                name="edit"
                className="color-primary"
                style={{
                  width: '16px',
                  height: '16px',
                }}
              />
            </button>
            <button
              className="btn btn--clear btn--small flex h-8 w-8 items-center border border-solid border-error-500 text-error-500"
              id="delete"
              onClick={() => {
                dispatch(removeUser(person.systemId));
              }}
            >
              <Icon
                name="delete"
                className="color-alert"
                style={{
                  width: '16px',
                  height: '16px',
                }}
              />
            </button>
          </div>
        )}
      </div>
    </li>
  );
};

export default UserListItemMobile;
